import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '-';

    // Remove all non-numeric characters
    const numericValue = value.replace(/\D/g, '');

    // Handle phone numbers with 10 digits
    if (numericValue.length === 10) {
      const areaCode = numericValue.slice(0, 2);
      const firstPart = numericValue.slice(2, 6);
      const secondPart = numericValue.slice(6);
      return `(${areaCode}) ${firstPart}-${secondPart}`;
    }

    // If not 10 digits, return the original or handle errors as necessary
    return value;
  }
}
